import { HeroGeometric } from "./shape-landing-hero";

function DemoHeroGeometric() {
  return (
    <HeroGeometric
      badge="Aimrane Digital — Freelance web"
      titleBefore="Transformer vos idées en"
      titleEmphasis="Sites web"
      titleAfter="qui génèrent des résultats et inspirent confiance."
      quote="Donnez forme à votre vision avec mon approche"
    />
  );
}

export { DemoHeroGeometric };
